import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { deleteData, getData, patchData, postData } from "src/utils/axios/serverHelper";
import { EQM4010_R01DetailDto, EQM4010_R01HeaderDto } from "./Dto_EQM4010_R01";
import { EQM4010_R01Filter } from "./Store_EQM4010_R01";

const apiUrl = `${config.apiUrl}/EQM4010_R01`;

export const getEQM4010_R01 = async (option: string, params: Partial<EQM4010_R01Filter>, listLength: number = 0) => {
	const url = `${apiUrl}/${option}`;

	return await getData<ResponseDto<EQM4010_R01HeaderDto[]>>(url, {
		params: {
			...params,
			listLength,
		},
	});
};

export const getEQM4010_R01AllCount = async (params: Partial<EQM4010_R01Filter>) => {
	const url = `${apiUrl}/allCount`;
	return await getData<ResponseDto<number>>(url, {
		params: {
			...params,
		},
	});
};

export interface EQM4010_R01DetailListParams {
	moldCd?: string;
	compCd?: string;
}

export const getEQM4010_R01DetailList = async (params: EQM4010_R01DetailListParams) => {
	const url = `${apiUrl}/detail`;
	return await getData<ResponseDto<EQM4010_R01DetailDto[]>>(url, {
		params,
	});
};

export const createEQM4010_R01 = async (data: Partial<EQM4010_R01DetailDto>[]) => {
	return await postData<Partial<EQM4010_R01DetailDto>[], ResponseDto<EQM4010_R01DetailDto[]>>(apiUrl, data);
};

export const postEQM4010_R01 = async (data: Partial<EQM4010_R01DetailDto>) => {
	return await postData<Partial<EQM4010_R01DetailDto>, ResponseDto<EQM4010_R01DetailDto>>(apiUrl, data);
};

export const patchEQM4010_R01 = async (data: Partial<EQM4010_R01DetailDto>) => {
	return await patchData<Partial<EQM4010_R01DetailDto>, ResponseDto<any>>(apiUrl, data);
};

export const deleteEQM4010_R01 = async (moldCleanNo: string) => {
	const url = `${apiUrl}/${moldCleanNo}`;
	return await deleteData<ResponseDto<any>>(url);
};

export const downloadExcel_EQM4010_R01 = async (params: EQM4010_R01DetailListParams) => {
	const url = `${apiUrl}/excel/`;

	return await getData<ResponseDto<string>>(url, {
		params,
	});
};
